import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { servicesApi } from '../lib/api';
import { ServiceCard } from '../components/ServiceCard';

export function ServicesPage() {
  const { data: services, isLoading } = useQuery({
    queryKey: ['services', true],
    queryFn: () => servicesApi.getAll(true).then((res) => res.data),
  });

  return (
    <>
      <Helmet>
        <title>Çözümler - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'}</title>
        <meta
          name="description"
          content={`${import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'} teknoloji çözümleri - Tüm hizmetlerimizi keşfedin`}
        />
      </Helmet>

      <div className="container-custom py-12">
        <h1 className="text-4xl font-bold mb-4">Çözümlerimiz</h1>
        <p className="text-xl text-gray-600 mb-12">
          İşletmeniz için ihtiyacınız olan tüm teknoloji çözümleri
        </p>

        {isLoading ? (
          <div className="text-center py-12">Yükleniyor...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services?.map((service: any) => (
              <ServiceCard
                key={service.id}
                slug={service.slug}
                title={service.title}
                summary={service.summary}
                imageUrl={service.images?.[0]?.url}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

